if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading-overlay').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading-overlay').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

class MobileStickyAtcController {
  constructor() {
    this.selector = '[data-mobile-sticky-on-scroll]';
    this.activeBodyClass = 'has-mobile-sticky-atc-active';
    this.mobileMedia = window.matchMedia('(max-width: 749px)');
    this.elements = [];
    this.stateByElement = new WeakMap();
    this.rafId = null;

    this.onScroll = this.scheduleUpdate.bind(this);
    this.onResize = this.onLayoutChange.bind(this);
    this.onMediaChange = this.onLayoutChange.bind(this);
    this.onPageHide = this.destroy.bind(this);
  }

  init() {
    this.elements = Array.from(document.querySelectorAll(this.selector));
    if (!this.elements.length) return;

    this.elements.forEach((element) => {
      const sentinel = document.createElement('div');
      sentinel.className = 'product-sticky-sentinel';
      sentinel.style.height = '1px';
      sentinel.style.margin = '0';
      sentinel.style.padding = '0';
      sentinel.style.pointerEvents = 'none';
      element.parentNode?.insertBefore(sentinel, element);
      this.stateByElement.set(element, { sentinel, thresholdY: null });
    });

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    window.addEventListener('pagehide', this.onPageHide);
    if (this.mobileMedia.addEventListener) {
      this.mobileMedia.addEventListener('change', this.onMediaChange);
    } else {
      this.mobileMedia.addListener(this.onMediaChange);
    }

    this.syncStaticState();
    this.update();
  }

  destroy() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('pagehide', this.onPageHide);
    if (this.mobileMedia.removeEventListener) {
      this.mobileMedia.removeEventListener('change', this.onMediaChange);
    } else {
      this.mobileMedia.removeListener(this.onMediaChange);
    }

    if (this.rafId) {
      window.cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    this.elements.forEach((element) => {
      const state = this.stateByElement.get(element);
      if (!state) return;
      element.classList.remove('is-sticky-active');
      state.sentinel.style.height = '1px';
      state.sentinel.remove();
      this.stateByElement.delete(element);
    });
    document.body.classList.remove(this.activeBodyClass);
    this.elements = [];
  }

  onLayoutChange() {
    this.syncStaticState();
    this.scheduleUpdate();
  }

  scheduleUpdate() {
    if (this.rafId) return;
    this.rafId = window.requestAnimationFrame(() => {
      this.rafId = null;
      this.update();
    });
  }

  syncStaticState() {
    this.elements.forEach((element) => {
      const state = this.stateByElement.get(element);
      if (!state) return;

      if (this.mobileMedia.matches) {
        if (!element.classList.contains('is-sticky-active')) {
          state.sentinel.style.height = '1px';
        }
      } else {
        element.classList.remove('is-sticky-active');
        state.sentinel.style.height = '1px';
        state.thresholdY = null;
      }
    });
  }

  update() {
    if (!this.mobileMedia.matches) {
      document.body.classList.remove(this.activeBodyClass);
      return;
    }

    let hasActiveSticky = false;
    this.elements.forEach((element) => {
      const state = this.stateByElement.get(element);
      if (!state) return;

      const isStickyActive = element.classList.contains('is-sticky-active');
      if (!isStickyActive) {
        const rect = element.getBoundingClientRect();
        const shouldStick = rect.bottom <= window.innerHeight;
        if (!shouldStick) return;

        state.thresholdY = window.scrollY;
        element.classList.add('is-sticky-active');
        state.sentinel.style.height = `${element.offsetHeight}px`;
        hasActiveSticky = true;
        return;
      }

      if (window.scrollY >= (state.thresholdY ?? 0)) {
        hasActiveSticky = true;
        return;
      }

      element.classList.remove('is-sticky-active');
      state.sentinel.style.height = '1px';
      state.thresholdY = null;
    });

    document.body.classList.toggle(this.activeBodyClass, hasActiveSticky);
  }
}

(() => {
  const controller = new MobileStickyAtcController();
  controller.init();
})();
